// eslint-disable-next-line import/no-anonymous-default-export
export default {
  'Animate old photos': 'Fotos Antigas Animadas',
  'Animate faces in your photos with AI technology, create vivid videos.':
    'Animar rostos em suas fotos com a tecnologia de IA, criar vídeos vívidos.',
  'Upload a photo': 'Carregar uma foto',
  'please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.':
    'Atenção: certifique-se de que o rosto nas fotos selecionadas esteja de frente para a lente, caso contrário, não poderá ser processado com sucesso.',
  'Uploaded successfully!': 'Carregado com sucesso!',
  'Please select a template below': 'Por favor, selecione um modelo abaixo',
  'Choose a GIF': 'Escolher um GIF',
  'Use this template': 'Usar este modelo',
  'Verify successfully! You will':
    'Verificou com sucesso! Você receberá o vídeo com {{email}} em breve.',
  'You will': 'Você receberá o vídeo com {{email}} em breve.',
  'What you should expect to happen next':
    'O que você pode esperar que aconteça em seguida:',
  'We will process your photo into a dynamic video.':
    'Nós processaremos sua foto em um vídeo dinâmico.',
  'After processing, we will send the video to your email.':
    'Após o processamento, enviaremos o vídeo para seu e-mail.',
  'You can check the video in your email.':
    'Você pode verificar o vídeo em seu e-mail.',
  'Your video will be delivered via email': 'Seu vídeo será enviado via e-mail',
  'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.':
    'Leva 20-30 minutos para sintetizar um vídeo dinâmico, por favor, seja paciente. Para proteger sua privacidade, as imagens carregadas serão automaticamente apagadas após o término do processamento.',
  'Your Email': 'Seu E-mail',
  'Last Name': 'Sobrenome',
  'First Name': 'Nome',
  'Go back': 'Voltar',
  'Invalid email address': 'Endereço de e-mail inválido',
  'Enter verification code': 'Digite o código de verificação',
  'Enter the verification code that we sent to':
    'Digite o código de verificação que enviamos para {{email}}.',
  Resend: 'Reenviar',
  'Verification code': 'Código de verificação',
  'Resend after': 'Reenviar depois dos {{num}} segundos',
  'The verification code is invalid. You can request a new one.':
    'O código de verificação é inválido. Você pode solicitar um novo código.',
  'Synthesize Video': 'Sintetizar Vídeo',
  Next: 'Próximo',
  'Too many attempts, please try again later.':
    'Muitas tentativas, por favor tente novamente Mais tarde.',
  'xx people is waitting in front of you to generate image.':
    ' criadores à sua frente, por favor, espere ...',
  'Animating...': 'Animando...',
  'You are in line...': 'Você está na fila...',
  'Failed to generate, click to retry.':
    'Falha ao gerar, clique para tentar novamente.',
  'The processing will be completed soon, are you sure you want to cancel it?':
    'O processamento será concluído em breve, você tem certeza de que deseja cancelá -lo?',
  freeAccountExceed: "Atualize para baixar imagem HD sem marca d'água.",
  freeAccountHD: 'Actualizar para descargar imágenes HD sin marca de agua.',
  UpgradeToDownloadAsGIF: 'Atualize para baixar vídeos como GIF.',
  UpgradeToUploadLimits: 'Atualize para uploads de imagens ilimitados.',
  DynamicTitle: 'HitPaw Online Animar Fotos Antigas',
  SizeLimit: 'Sem Limites de Tamanho de Imagem',
  UploadLimit: 'Uploads de Imagem Ilimitados',
  DownloadNoWaterMark: "Baixe a Imagem HD sem Marca d'água",
  DownloadGIF: 'Baixe o Vídeo como GIF',
  Weekly: 'Semanalmente',
  Monthly: 'Mensualmente',
  Yearly: 'Anualmente',
  priceWeek: 'R$19,99',
  priceMonth: 'R$9,99',
  priceYear: 'R$5,99',
  Week: 'Semana',
  billMonth: 'R$39,99 Pagado Mensualmente',
  billYear: 'R$249,99 Pagado Anualmente',
};
